import { UserGroups } from 'pages/TeamMembers/const'
import { type Profile } from 'types/authentication/Profile'
import { RoleGroupMatchTypes, useHasRoleGroups } from './useHasRoleGroups'

/**
 * Hook to check if the current user is a compliance-only user
 *
 * A compliance view user is someone who has:
 * - ONLY the Compliance role, OR
 * - ONLY the Compliance and Login roles
 *
 * @returns true if user has exactly Compliance role or exactly Compliance + Login roles
 */
export const useComplianceViewHelper = (profile: Profile): boolean => {
  const roleGroupsToCheck = [[UserGroups.Compliance], [UserGroups.Compliance, UserGroups.Login]]
  return useHasRoleGroups(profile, roleGroupsToCheck, RoleGroupMatchTypes.EXACT)
}
